<template>
  <b-alert :show="visible && alertShowDuration" 
                  dismissible 
                  fade
                  :variant="variant" 
                  @dismissed="() => updateAlertShowDuration(0)"
                  @dismiss-count-down="updateAlertShowDuration">
    <slot name="content"/>
</b-alert>                       
</template>
<script>
const defaultAlertShowDuration = 5; // The number of seconds the alert will be displayed
export default {
  props: {
    variant: {
      type: String,
      default: 'danger'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      alertShowDuration: defaultAlertShowDuration
    }
  },
  methods: {
    /** 
     * Counting down listener that gets updated by the alert component on every second.
    */
    updateAlertShowDuration (sec = defaultAlertShowDuration) {
      this.alertShowDuration = sec;
      if (this.alertShowDuration === 0) {
        this.$emit('dismissed');
        this.alertShowDuration = defaultAlertShowDuration;
      }
    }
  }
}
</script>